import React, {useState, useEffect, Fragment} from "react";
import { addPokemonToCart, clearErrors, addPokemonToWishlist } from "../../redux/actions/cartAndWishlistActions";
import { useDispatch, useSelector } from "react-redux";


export const SearchPokemon = ({ result}) => {


    const [ searchInput, setSearchInput ] = useState("");
    const [searchTerm, setSearchTerm] = useState(""); //not set fix
    const [filterSearch, setFilterSearch] = useState(null); 


      const dispatch = useDispatch()

      const handlerChange = async(e) => {
        setSearchInput(e.target.value)
        setSearchTerm(searchInput)
     }


     //__complete logic on submit search
     const handleSubmit = ()=>{
            console.log("button is testing nnnnnnnnnnn")
     }





     useEffect(() => {

       result && result.searchItems.reduce((acc, poke, i, arr) => {
              // filter base
               setFilterSearch(()=> arr && arr
                      .filter((poke) => {
                              return poke.name.toLowerCase().includes(searchInput.toLowerCase())
                    })
               )
             
       }, [])


    }, [searchInput, searchTerm]);



         useEffect(()=>{

             dispatch(clearErrors())

               filterSearch && filterSearch
               .filter((poke) =>
                 poke.name === searchTerm? poke.name : poke
               )
                .map(el=> el.name)
    
         }, [filterSearch])



    return (
               <>
                              {/* select country__________ */}
                   <div className="searchPokemonWrapper">
                            <div className="searcInputWrapper">
                                <div className="searchWrap">
                                <div className="search">
                                    <input type="text" 
                                      className="searchTerm" 
                                      autoComplete="off"
                                      name="search"
                                      value={searchInput}
                                      placeholder="What are you looking for?"
                                      onChange={(e) => handlerChange(e)} 
                                    />
                                    <button type="submit" className="searchButton"
                                      onClick={() => handleSubmit}
                                    >
                                        <i className="fa fa-search">search</i>                                        
                                    </button>
                                </div>
                            </div>
                        </div>
                 </div>


                 {/* search results */}
                {

                    filterSearch && filterSearch.filter((poke) =>
                    // searchTerm === poke.name? poke.name : poke  
                    poke.name === searchTerm? poke.name : poke

                    )
                    .map((el)=>  <Fragment key={el.id}>
                                        <SearchResults
                                            name = {el.name}
                                            id={el.id}
                                            price={el.weight}
                                            searchInput={searchInput}
                                            setSearchInput={setSearchInput}
                                        />
                                </Fragment>
                      )
                }
                 
        </>
    )
}




const SearchResults = ({name, id, price, searchInput, setSearchInput}) => {

    const [style, setStyle] = useState({display: 'none'});
    const dispatch = useDispatch()

    const handleAddToWishList  = (id) => {

        dispatch(addPokemonToWishlist(id))
        setSearchInput("")       
   }

   const handleBuy  = (id) => {

    dispatch(addPokemonToCart(id))
    setSearchInput("")       
}


    return (

          <>
             <div className="searchResults">
               {
                  searchInput? (
                      <div className="searchResultsList">                        

                  <div style={{border: '1px solid gray', width: '100%', height: 'maxCotent', padding: 1, margin: 1}}
                            onMouseEnter={e => {
                                setStyle({display: 'block'});
                            }}

                            onMouseLeave={e => {
                                setStyle({display: 'none'})
                            }}
                   >                    
                       <div className="onHoverWrapper">
                                <div className="searchResultInfoWrap">
                                     <span className="searchResultName">{name}</span>
                                </div>
                                <div className="onHoverBtnWrapper">
                                    <button style={style}
                                      onClick={()=> handleAddToWishList(id)}
                                    >
                                          add to wishlist
                                    </button>
                                    <button style={style}
                                        onClick={()=> handleBuy(id)}
                                    >
                                          <span className="buyDeploySearchResults">Buy 
                                               <span className="searchResultPrice">
                                                   <span className="serchResultEuro">€</span>
                                                   {price+3}</span>
                                           </span> and deploy
                                    </button>
                                </div>        
                        </div>        
                   </div>
                      </div>
                  ) : ""
               }

             </div>
          </>
      )
}



